// Module
var code = "<div class=\"widget-content flex-widget-container alarm-gauges\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"> </wt-loading-panel> <wt-status-display clicked=\"vm.clicked\" statuses=\"vm.statuses\"> </wt-status-display> </div>";
// Exports
module.exports = code;